import React from 'react'
import Text from '../text'
import Flex from '../flex'
import Button from '../button'
import DeleteIcon from '../svg/delete'
import EditIcon from '../svg/editIcon'

const PaymentCard = ({onDelete, cardId,
                         cardNumber,
                         nameonCard,
                         bankName,
                         nickName,
                         cardType,
                         zipCode}) => {
    return (
        <div className="payment-card">
            <div className="action-buttons">
                {/* <Button 
                    type="button" 
                    className="vdc-item-btn-edit" 
                    linkInfo 
                    text={<EditIcon />}
                    onClick={onEdit}
                /> */}
                <Button 
                    type="button"
                    linkDanger 
                    text={<DeleteIcon />}
                    onClick={onDelete}
                />
            </div>
            <Flex className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Card Number Last 4" />
                <Text type="SPAN" className="vdc-text" text={cardNumber} />
            </Flex>
            <Flex className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Name on Card" />
                <Text type="SPAN" className="vdc-text" text={nameonCard} />
            </Flex>
            <Flex className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Nick Name" />
                <Text type="SPAN" className="vdc-text" text={nickName} />
            </Flex>
            <Flex className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Card Type" />
                <Text type="SPAN" className="vdc-text" text={cardType} />
            </Flex>
            <Flex className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Zip Code" />
                <Text type="SPAN" className="vdc-text" text={zipCode} />
            </Flex>
        </div>
    )
}

export default PaymentCard